/** Shared filter for every api/ClientReport run/export/batch call. Null list = no filter. */
export class ClientReportFilter {
    startDate: string;               // yyyy-MM-dd
    endDate: string;                 // yyyy-MM-dd
    companyIds: number[] | null;     // brand filter; empty/null = all permitted (server enforces)
    clientIds: number[] | null;
    studentIds: number[] | null;
    coordinatorIds: number[] | null; // accepted by the API, not applied by any proc
    tutorIds: number[] | null;
    placementIds: number[] | null;   // batch-only scoping; null on run/export
    statusIds: number[] | null;      // Attendance/MILPR session report status (2/3/4); null = all submitted
}
